import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'react-bootstrap/Button';
import { TitleFormattedMessage } from '../../components/titleFormattedMessage';
import PropdocsModal from '../../components/modal/PropdocsModal';

interface ArchiveModalProps {
  isOpen?: boolean;
  onClose: () => void;
  onUpdateArchived: () => void;
}

const ArchiveModal = ({ isOpen = false, onClose, onUpdateArchived }: ArchiveModalProps) => {
  return (
    <PropdocsModal
      show={isOpen}
      setShow={onClose}
      size="md"
      title={<FormattedMessage id="title.archive-deal" defaultMessage="Archive Deal" />}
    >
      <>
        <div style={{ marginBottom: '1.5rem' }}>
          <p>
            <FormattedMessage
              id="phrase.archive-deal"
              defaultMessage="Archiving a deal means it becomes inactive, you can no longer create documents for this deal."
            />
          </p>
          <p>
            <FormattedMessage
              id="phrase.archive-deal-reversal"
              defaultMessage="Archiving can be reversed at a later date."
            />
          </p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <Button variant="link" className="text-secondary" onClick={onClose}>
            <FormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              onUpdateArchived();
            }}
          >
            <TitleFormattedMessage id="cta.archiveDeal" defaultMessage="Archive Deal" />
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default ArchiveModal;
